<template>
  <transition name="modal" v-if="open">
    <div class="modal-mask modal" v-bind:class="modalClass">
      <div class="modal-wrapper" @click="hideModal">
        <div class="modal-container" @click.stop>
          <div v-if="showHeader||showClose" class="modal-header">
            <i v-if="showClose" @click="hideModal" class="fa fa-times pull-right"></i>
            <slot v-if="showHeader" name="header">
              <h3>{{title}}</h3>
            </slot>
          </div>

          <div class="modal-body">
            <slot>default body</slot>
          </div>

          <div v-if="showFooter" class="modal-footer">
            <slot name="footer">
              <div class="text-right">
                <button type="button" class="btn btn-default" @click="hideModal">OK</button>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  mixins: [],
  props: {
    open: {type: Boolean, default: false},
    showHeader: {type: Boolean, default: true},
    showClose: {type: Boolean, default: true},
    showFooter: {type: Boolean, default: true},
    bodyModal: {type: Boolean, default: false},
    title: {type: String, default: ''},
    size: {type: String, default: '', validator: value => ['', 'default', 'small', 'large'].indexOf(value) >= 0},
    position: {type: String, default: 'top', validator: value => ['top', 'center'].indexOf(value) >= 0}
  },
  data() {
    return {
      sid: 'mod' + Math.round(Math.random() * 1000000)
    };
  },
  mounted() {
    if (this.open && this.bodyModal) {
      this.toggleBodyClass('addClass', 'modal-open');
    }
  },
  computed: {
    modalClass: {
      get() {
        const result = [];
        switch (this.size) {
          case 'large':
            result.push('modal-lg');
            break;
          case 'small':
            result.push('modal-sm');
            break;
        }
        switch (this.position) {
          case 'center':
            result.push('modal-centered');
            break;
          default:
            result.push('modal-top');
            break;
        }
        return result;
      }
    }
  },
  methods: {
    hideModal($event) {
      this.toggleBodyClass('removeClass', 'modal-open'); // na wszelki wypadek jakby parent nie zmienił open
      this.$emit('close');
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    }
  },
  watch: {
    open(next, prev) {
      if (this.bodyModal) {
        if (next) {
          this.toggleBodyClass('addClass', 'modal-open');
        } else {
          this.toggleBodyClass('removeClass', 'modal-open');
        }
      }
    }
  }
};
</script>

<style>
body.modal-open {
  overflow: hidden;
  position: fixed;
}

.modal-mask {
  position: fixed;
  z-index: 9997;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  z-index: 9999;
  display: table-cell;
}
.modal.modal-top .modal-wrapper {
  vertical-align: top;
  padding-top: 60px;
}

.modal.modal-centered .modal-wrapper {
  vertical-align: middle;
}

.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 0px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal.modal-lg .modal-container {
  width: 90%;
}
.modal.modal-sm .modal-container {
  width: 300px;
}
.modal-header,
.modal-body,
.modal-footer {
  padding-left: 20px;
  padding-right: 20px;
}
.modal-header,
.modal-footer {
  padding: 10px 20px;
}

.modal-header .fa.fa-times {
  margin-top: 0.3em;
  cursor: pointer;
}

.modal-body {
  margin: 20px 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
